<template>
  <div class="bulkDomainDeletionModal position-relative">
    <div class="modal fade" id="bulkDomainDeletionModal" tabindex="-1" role="dialog" aria-labelledby="bulkDomainDeletionModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Bulk Delete Domains</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="loader" v-if="loading"></div>
            <template v-else-if="!loading & stepper === 1">
              <div  class="row pl-15 pr-15 mt-10">
                <div class="col-md-6 form-check-radio">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="selectedValue" type="radio" name="checkAllDomains" id="inputDomain" value="checkAll"> Select all domains
                    <span class="form-check-sign"></span>
                  </label>
                </div>
                <div class="col-md-6 form-check-radio">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="selectedValue" type="radio" name="uncheckAllDomains" id="status" value="uncheckAll"> Uncheck all domains
                    <span class="form-check-sign"></span>
                  </label>
                </div>
              </div>
              <div class="row mt-5">
                <perfect-scrollbar class="scroll-area col-md-12">
                  <table class="table single-outage-table">
                    <thead>
                    <tr>
                      <th><b>Domain Name</b></th>
                      <th class="text-center">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in accounts" :key="index">
                      <td>{{ row.domain }}   <i  v-if="row.addonIndex=== null " class="fa fa-question-circle text-primary" data-toggle="tooltip" data-placement="top" title="This is the primary domain of the plan. You cannot remove primary domain until all addons are selected."></i></td>
                      <td v-if="row.addonIndex === null">
                        <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center" >
                          <input type="checkbox" class="custom-control-input" :name="`${index}forPrimary`" v-model="checkAll" :value="row" :id="`${index}forPrimary`" :disabled="isPrimaryDisabled" />
                          <label class="custom-control-label" :for="`${index}forPrimary`"></label>
                        </div>
                      </td>
                      <td v-else>
                        <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center">
                          <input type="checkbox" class="custom-control-input" name="identifiers" v-model="checkAll" :value="row" :id="index" :disabled="isAddonDisabled"  />
                          <label class="custom-control-label" :for="index"></label>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </perfect-scrollbar>
              </div>
              <hr class="mt-20 mb-20">
              <div class="mt-5">
                <label class="fw-600">Select Action</label>
                <select class="form-control" v-model="selectedActionType">
                  <option v-for="action in actionOptions" :value="action" :key="action.text">
                    {{action.text}}
                  </option>
                </select>
              </div>
              <div class="mt-5">
                <button  class="btn btn-success pull-right" :disabled="!(selectedActionType.text && checkAll.length)" @click.prevent="stepper++">
                  <span >Next</span>
                </button>
              </div>
            </template>
            <template v-else>
              <div  class="row pl-15 pr-15 mt-10">
                <div class="col-md-12">
                  <div class="fw-500 fs-16 text-primary">Are you sure you want to perform the following action on the selected domains?</div>
                  <br>
                  <div class="mr-10 fw-600">Selected Action</div>
                  <input class="form-control" :value="selectedActionType.text" :disabled="true" />
                </div>
              </div>
              <div class="row mt-10">
                <div class="col-md-12">
                  <perfect-scrollbar class="scroll-area col-md-12">
                    <table class="table single-outage-table">
                      <thead>
                      <tr>
                        <th><b>Domain Name</b></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, index) in checkAll" :key="index"  >
                        <td>{{ row.domain }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </perfect-scrollbar>
                </div>
              </div>
              <hr class="mt-20 mb-20">
              <div class="mt-5">
                <button class="btn btn-success pull-right" :disabled="loading" @click.prevent="submit()">
                  <span>Remove</span>
                </button>
                <button  class="btn btn-danger pull-right" :disabled="loading" @click.prevent="stepper--">
                  <span>Back</span>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import swal from "sweetalert2";
export default {
  name: "bulkDomainDeletionModal",
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      parentAccounts: [],
      bulkDomainDeletionModal: '',
      stepper: 1,
      selectedPlanIndex: null,
      checkAll: [],
      isPrimaryDisabled: false,
      isAddonDisabled: false,
      selectedValue: '',
      usingWithOutUsingFlag : 'using',
      loading: false,
      selectedFilteredCloudFareAccount: null,
      selectedActionType: {
        text: '',
        action: '',
      },
      actionOptions: [
        {text: 'Delete', action: 'delete'}
      ],
      serverIP: null,
    }
  },

  computed: {
    custID() {
      return this.$store.getters["customer/id"];
    },
    customerInfo () {
      return this.$store.getters["customer/details"];
    },
    docID() {
      return this.$store.getters["customer/docID"];
    },
    accounts() {
      let hostingAccounts = this.$store.getters["hosting/accountsOrdered"];
      hostingAccounts = hostingAccounts.filter(acc => {
        if (!acc.deleted) {
          return acc;
        }
        return false;
      });
      hostingAccounts = hostingAccounts.filter(el => el.planIndex === this.selectedPlanIndex)
      return hostingAccounts
    },
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    selectedValue (val) {
      if (val === 'checkAll') {
        for (const row of this.accounts) {
          this.checkAll.push(row)
        }
        this.selectedFilteredCloudFareAccount= null;
        this.usingWithOutUsingFlag = 'using'
      } else if (val === 'uncheckAll') {
        this.checkAll = [];
        this.selectedFilteredCloudFareAccount= null;
        this.usingWithOutUsingFlag = 'using'
      }
    },
    checkAll (val) {
      if(val.length) {
        const domains = val.map((value) => {
          return value.domain
        })
        console.log('this domains', domains, val)
        this.isPrimaryDisabled = false
        this.isAddonDisabled = false;
        this.accounts.forEach(account => {
          if (account.addonIndex !== null && !domains.includes(account.domain)) {
            this.isPrimaryDisabled = true
          }
        })
      }
    },
    isPrimaryDisabled(value){
      if(value === true){
        console.log('I was called here')
        this.checkAll =this.checkAll.filter((value) => {
          return value.domain !== this.parentAccounts.domain && value.addonIndex !== null
        })
      }
    }
  },
  mounted(){
    $('#bulkDomainDeletionModal').on('hidden.bs.modal', this.handleModalHidden);
  },
  methods: {
    handleModalHidden() {
      this.selectedValue ='uncheckAll';
    },
    async load(account) {
      this.checkAll = []
      console.log('account',account)
      this.stepper = 1
      this.parentAccounts = account;
      this.serverIP= account.serverIP
      this.selectedPlanIndex = account.planIndex
      console.log('all accounts', this.selectedPlanIndex)
      this.isPrimaryDisabled = false;
      this.isAddonDisabled=  false;
      this.selectedActionType = {
        text: '',
        action: '',
      }
      this.selectedValue ='checkAll';
      this.fixModal()
      $('#bulkDomainDeletionModal').modal('show');
    },
    fixModal() {
      /* eslint-disable */
      $(document).ready(function() {
        $(".modal-backdrop").appendTo(".bulkDomainDeletionModal");
      });
      /* eslint-enable */
    },
    async updateAllDeleteAccounts(){
      const {docID: UID} = this.customerInfo;
      console.log(UID, 'Selected DOC ID')
      const selectedDomains = [];

      this.checkAll.forEach((value)=>{
        selectedDomains.push(value.domain)
      })
      this.$http.post("domain/bulk-delete", {
        grant_type: "token",
        customerId: UID,
        custId: this.custID,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        ip: this.serverIP,
        hostingAccountId: this.docID,
        selectedDomains: selectedDomains,
        planIndex: this.selectedPlanIndex,
        isAdmin: true,
      });
    },
    async submit(){
      try {
        if (!this.checkAll.length) {
          return;
        }
        this.loading = true
        this.updateAllDeleteAccounts()
        this.loading = false
        await swal('Success', 'Remove domains in progress', 'success')
        $("#bulkDomainDeletionModal").modal('hide');
      }
      catch(e){
        this.loading = false
        console.log(e.toString(), 'Error Occurred while wrong removing domains')
        $("#bulkDomainDeletionModal").modal('hide');
        await swal('Error', 'Something went wrong removing domains', 'error')
      }
    },
  },
}
</script>

<style scoped>

</style>


